module.exports = __webpack_public_path__ + "static/media/logo_with-circle.0589e047.png";